<template>
  <div class="footer">
    <div class="footer-nav">
      <div class="nav-left" style="width: 352px">
        <div>{{ $t('footer.contactMethod') }}</div>
        <ul>
          <li>
            <span>{{ $t('footer.customerServiceTel') }}</span>
            <span>0898-65333514</span>
          </li>
          <li style="white-space: nowrap">
            <span>{{ $t('footer.customerServiceEmail') }}</span>
            <a href="mailto:@hnyzy.gov.cn">@hnyzy.gov.cn</a>
          </li>
        </ul>
      </div>
      <div class="nav-left">
        <div>{{ $t('footer.userCenter') }}</div>
        <ul>
          <li>
            <a href="/help.html#/question?key=3&keypath=3-1&num=3-1-1">{{ $t('footer.howToMediate') }}</a>
          </li>
          <!-- <li>
            <a href="/help.html#/question?key=3&keypath=3-2&num=3-2-1">如何快速咨询</a>
          </li>-->
          <li>
            <a href="/help.html#/question?key=3&keypath=3-4&num=3-4-1">{{ $t('footer.howToViewResults') }}</a>
          </li>
          <li>
            <a href="/meeting.html#/invite" target="_blank">{{ $t('header.mediationCentre') }}</a>
          </li>
        </ul>
      </div>
      <div class="nav-left">
        <div>{{ $t('footer.platformService') }}</div>
        <ul>
          <li>
            <a href="javascript:;" @click="lawMore">{{ $t('header.regulatoryCase') }}</a>
          </li>
          <!-- <li>
              <a href="/law.html#/lawSearch">{{$t('header.lawsAndRegulations')}}</a>
          </li>-->
          <!-- <li>
              <a href="/advice.html">法律咨询</a>
          </li>-->
          <!-- <li>
              <a href="/case.html#/caseSearch">{{$t('header.caseLibrary')}}</a>
          </li>-->
        </ul>
      </div>
      <div class="nav-right" style="float: left; margin-left: 75px">
        <img src="../../module/home/img/qrcode.jpg" alt="海南涉外民商事法庭案件多元化解平台小程序" />
        <p>{{ $t('footer.smallProgram') }}</p>
      </div>
      <div class="nav-right nav-logo">
        <img src="../../module/home/img/beiming.png" alt />
        <img src="../../module/home/img/huawei.png" alt />
      </div>
    </div>
    <div class="footer-info">
      <div class="row clearfix">
        <div>
          <span>{{ $t('home.organizer') }}海南省高级人民法院、海南省第一中级人民法院</span>
          <span>{{ $t('home.ChineseDomain') }}海南涉外民商事法庭案件多元化解平台</span>
          <span>{{ $t('home.filingNumber') }}琼ICP备15002050号-7</span>
          <span>{{ $t('home.courtAddress') }}海口市白驹大道8号</span>
          <span>{{ $t('home.courtTel') }}0898-65333514</span>
          <span>{{ $t('home.technicalServiceHotline') }}0571-28854968</span>
          <!--<a-->
          <!--href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010702000002"-->
          <!--class="beian"-->
          <!--target="_blank"-->
          <!--&gt;-->
          <!--<img src="@/module/index/assets/common/beian.png"> 粤公网安备 11010702000002-->
          <!--</a>-->
        </div>
        <!--<div class="right">&copy; 2018 www.gzinternetcourt.gov.cn 版权所有</div>-->
      </div>
    </div>
    <div>
      <span id="_ideConac" style="display: block; text-align: center"
        ><a href="https://bszs.conac.cn/sitename?method=show&amp;id=4412B14BDD641F59E06310291AACE515" target="_blank"
          ><img
            id="imgConac"
            vspace="0"
            hspace="0"
            border="0"
            src="https://dcs.conac.cn/image/red_error.png"
            data-bd-imgshare-binded="1" /></a
      ></span>
    </div>
  </div>
</template>
<script>
import { getStore, setStore } from '@/publicResource/utils/utils.js'
import config from '@/publicResource/config/config.js'
export default {
  data() {
    return {}
  },
  methods: {
    tolink() {
      //      let logininfo = JSON.parse(getStore("loginInfouser"));
      //      let linkurl = "";
      //      if (logininfo) {
      //        //        linkurl = "/userCenter/center/third";
      //        linkurl = "https://www.gzinternetcourt.gov.cn";
      //      } else {
      //        setStore("tolink", "/userCenter/center/third");
      //        //        linkurl = "/useraction/login";
      //        linkurl = "https://www.gzinternetcourt.gov.cn";
      //      }
      window.location.href = 'https://www.gzinternetcourt.gov.cn'
    },
    lawMore() {
      let currentLa = localStorage.getItem('locale')
      if (currentLa === 'en_US') {
        currentLa = 'en'
      } else if (currentLa == 'zh_TW') {
        currentLa = 'tc'
      } else {
        currentLa = 'zh'
      }
      // window.open(
      //   config.searchCaseUrl + '/?lang=' + currentLa + '#/'
      // )
      window.open('https://law.odrcloud.cn/gd-fa/index')
    }
  }
}
</script>
<style lang="scss" scoped>
.footer {
  .row.clearfix {
    /*width: 1116px;*/
    width: 1270px;
    // width: 1167px;
  }
  background-color: #17191b;
  .footer-nav {
    margin: 0 auto;
    width: 1116px;
    height: 200px;
    padding-top: 30px;
    .nav-left {
      color: #fff;
      width: 160px;
      float: left;
      div {
        font-size: 16px;
        line-height: 38px;
        text-align: left;
      }
      li {
        font-size: 12px;
        line-height: 28px;
        text-align: left;
        a {
          color: #fff;
        }
      }
    }
    .nav-right {
      float: right;
      width: 135px;
      padding-top: 10px;
      img {
        display: block;
        width: 135px;
        height: 135px;
        border-radius: 4px;
      }
      p {
        text-align: center;
        font-size: 12px;
        color: #fff;
        padding-top: 15px;
      }
    }
    .nav-logo {
      width: 140px;
      img {
        width: 140px;
        height: auto;
      }
      img:first-of-type {
        margin-top: 20px;
        margin-bottom: 25px;
      }
    }
  }
  .footer-info {
    background-color: #0f0f10;
    color: #fff;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    a {
      color: #fff;
    }
    span {
      padding-right: 5px;
    }
    .beian {
      position: relative;
      padding-left: 28px;
      img {
        position: absolute;
        left: 8px;
        top: -2px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/publicResource/components/footer.vue